<p-dialog header="New Note" [(visible)]="display" [modal]="true" [style]="{width: '480px'}"
    [draggable]="false" [resizable]="false" appendTo="body">

    <div class="form-group">
        <label>Type</label>
        <p-dropdown [options]="typeOptions" [(ngModel)]="selectedType" optionLabel="label" optionValue="value"
            placeholder="Select type" (onChange)="onTypeChange()" [style]="{width: '100%'}"
            appendTo="body"></p-dropdown>
    </div>

    <div class="form-group" *ngIf="selectedType">
        <label>{{ selectedType === 'collections' ? 'Client (open collections)' : (selectedType | titlecase) }}</label>
        <p-dropdown [options]="entityOptions" [(ngModel)]="selectedEntity" optionLabel="label" dataKey="id"
            [filter]="true" filterBy="label,sublabel" [showClear]="true"
            [virtualScroll]="true" [virtualScrollItemSize]="50" panelStyleClass="universal-note-entity-panel"
            [disabled]="loadingEntities"
            [placeholder]="loadingEntities ? 'Loading...' : 'Select or type to filter'"
            [style]="{width: '100%'}" appendTo="body">
            <ng-template let-item pTemplate="item">
                <div>
                    <div>{{ item.label }}</div>
                    <small class="text-muted" *ngIf="item.sublabel">{{ item.sublabel }}</small>
                </div>
            </ng-template>
        </p-dropdown>
        <a *ngIf="recordLink" class="record-link" (click)="openRecord()">Open record &rarr;</a>
    </div>

    <div class="form-group" *ngIf="selectedType === 'franchisee'">
        <label>Call Results</label>
        <p-dropdown [options]="callResultsList" [(ngModel)]="callResult" optionLabel="title" optionValue="value"
            placeholder="Select call result" [style]="{width: '100%'}" appendTo="body"></p-dropdown>
    </div>

    <div class="form-group" *ngIf="selectedType === 'collections'">
        <label>Call Result</label>
        <p-dropdown [options]="callOptions" [(ngModel)]="callOption" optionLabel="name"
            placeholder="Select call result" [style]="{width: '100%'}" appendTo="body"></p-dropdown>
    </div>

    <div class="form-group" *ngIf="selectedType === 'collections'">
        <label>Contact Date</label>
        <p-calendar [(ngModel)]="contactDate" dateFormat="mm/dd/yy" [showIcon]="true"
            [style]="{width: '100%'}" appendTo="body"></p-calendar>
    </div>

    <div class="form-group" *ngIf="selectedType">
        <label>Note</label>
        <textarea pInputTextarea [(ngModel)]="note" rows="4" autoResize="autoResize"
            style="width: 100%;" placeholder="Enter note"></textarea>
    </div>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" class="p-button-text" (click)="display = false"
            [disabled]="saving"></button>
        <button pButton type="button" label="Save" (click)="save()" [disabled]="!canSave || saving"
            [loading]="saving"></button>
    </ng-template>
</p-dialog>
<p-toast position="top-right"></p-toast>
